import React, { PureComponent } from "react";
import {
	PieChart,
	Pie,
	Sector,
	Cell,
	ResponsiveContainer,
	Label,
	Tooltip,
	Legend,
} from "recharts";
import styles from "./style.module.scss";

const data = [
	{ name: "Group A", value: 800 },
	{ name: "Group B", value: 200 },
];
const colorsGreen = ["#27AE60", "#151A20"];
const colorsRed = ["#EB5757", "#151A20"];

const MonitorPieChart = ({ responseData, percentage, colors }: any) => {
	return (
		<div className={styles.pieBody}>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "center",
					position: "relative",
				}}
			>
				<div className={styles.percentage}>{percentage}</div>
				<div>
					<PieChart width={140} height={140}>
						<Pie
							data={responseData}
							cx="50%"
							cy="50%"
							innerRadius={30}
							outerRadius={55}
							fill="#8884d8"
							paddingAngle={2}
							dataKey="value"
							nameKey="name"
						>
							{responseData?.map((entry: any, index: any) => (
								<Cell
									key={`cell-${index}`}
									fill={
										parseInt(percentage?.slice(0, -1)) > 50
											? colorsRed[index % colorsRed.length]
											: colorsGreen[index % colorsGreen.length]
									}
								/>
							))}
						</Pie>
					</PieChart>
				</div>
			</div>
		</div>
	);
};

export default MonitorPieChart;
